import { render, staticRenderFns } from "./EditHeaderDocument.vue?vue&type=template&id=f9a302f8&scoped=true&"
import script from "./EditHeaderDocument.vue?vue&type=script&lang=js&"
export * from "./EditHeaderDocument.vue?vue&type=script&lang=js&"
import style0 from "./EditHeaderDocument.vue?vue&type=style&index=0&id=f9a302f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a302f8",
  null
  
)

export default component.exports